import styled from 'styled-components'
import { Dialog } from '@diversioteam/diversio-ds'

export const DialogWrapper = styled(Dialog)`
    .MuiDialog-paper {
        margin-left: 250px;
    }

    .MuiDialogTitle-root img {
        display: flex;
        width: 100%;
        margin-bottom: 30px;
    }
`
